import { BOX_STATUS } from '../constants'
import { getTimeLeft, type TimeLeft } from '../functions/getTimeLeft'
import { useMemo } from 'react'
import { type BoxDto, UserVoteSummaryDtoStatusEnum } from '../types/generated'
import { useBoxChoices } from './useBoxChoices'

interface BoxStatus {
  canClaimReward: boolean
  isFinish: boolean
  isWinner: boolean
  timeLeft: TimeLeft
}

export const useBoxStatus = (box: BoxDto): BoxStatus => {
  const timeLeft = getTimeLeft(Number(box.endTime))
  const { winningChoice } = useBoxChoices({ box })

  const data: BoxStatus = useMemo(() => {
    const isOpen =
      box.boxStatus === BOX_STATUS.STATE_VOTING_OPEN && !timeLeft.isExpired

    const isWinner = Boolean(winningChoice)

    return {
      canClaimReward: Boolean(
        isWinner &&
        winningChoice &&
        winningChoice.user_vote_summary?.status ===
          UserVoteSummaryDtoStatusEnum.UNCLAIMED,
      ),

      isFinish: !isOpen && box.winner !== null,
      isWinner,
      timeLeft,
    }
  }, [box, timeLeft, winningChoice])

  return data
}
